export const BREAKPOINT_TABLET = "1023px"
export const BREAKPOINT_TESTIMONIALS = "1170px"
export const BREAKPOINT_MOBILE = "767px"
export const BREAKPOINT_TABLET_PRO_LANDSCAPE = "1365px"
